import {lightboxProduct} from "./components/lightbox";
import tabs from "./components/tabs";
import productStores from "./components/product-stores";

window.addEventListener('DOMContentLoaded', () => {
    console.log("Single Product JS Started");

    lightboxProduct();
    tabs();
    productStores();

    // Ancore verso le tabs
    document.querySelectorAll('.js-anchor-tab').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
            document.querySelector(anchor.getAttribute('href')).click();
        });
    });
});
